export const OBJECTSTORE_ROQ_DAYS = "RoqDays";